export default __webpack_public_path__ + "static/media/premium-lesson.48a3be60.svg";